export enum ScreenComponent {
	Root = "",
	Contact = "Contact_Us",
	AboutUs = "About_Us",
	OurFleet = "Our_Fleet",
}
